export default "__VITE_ASSET__I6DcC6k___"